export default __webpack_public_path__ + "static/BannerHtml-a9c4d363ab47ca5a7f584dc1850e0104.jpg";